
export const configMonthToDateByTL = [
  { name: "name", label: "Nama TL", options: { sort: false } },
  { name: "lastMonth", label: "Last Month", options: { sort: false } },
  { name: "thisMonth", label: "This Month", options: { sort: false } },
  { name: "growth", label: "Growth", options: { sort: false , customBodyRender: (val) => (val!== null ? `${val}%` : null)} },
  { name: "forecasting", label: "Proyeksi", options: { sort: false } },
];